import { Switch } from '../../Switch'
import { Container } from '../Container'

function Switches() {
  return (
    <>
      <Container label='Switcher, off, size - 16px'>
        <Switch />
      </Container>
      <Container label='Switcher, on, size - 16px'>
        <Switch value />
      </Container>
      <Container label='Switcher, off, disabled, size - 16px'>
        <Switch disabled />
      </Container>
      <Container label='Switcher, on, disabled, size - 16px'>
        <Switch disabled value />
      </Container>
      <Container label='Switcher, off, error, size - 16px'>
        <Switch hasError />
      </Container>
    </>
  )
}

export default Switches
